import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { 
  Activity, 
  Map as MapIcon, 
  Users, 
  User, 
  Settings,
  Handshake
} from 'lucide-react';

const Navigation = ({ orientation = 'vertical' }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  const navItems = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: Activity
    },
    {
      name: 'Map',
      path: '/map',
      icon: MapIcon
    },
    {
      name: 'Challenges',
      path: '/challenges',
      icon: Users
    },
    {
      name: 'Team',
      path: '/teams',
      icon: Handshake
    },
    {
      name: 'Profile',
      path: '/profile',
      icon: User
    },
    {
      name: 'Settings',
      path: '/settings',
      icon: Settings
    }
    
  ];

  // For mobile (bottom navigation)
  if (orientation === 'horizontal') {
    return (
      <nav className="flex justify-between items-center px-4 py-2">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="flex flex-col items-center"
          >
            <div className={`p-2 ${
              currentPath === item.path 
                ? 'text-primary ' 
                : 'text-gray-500'
            }`}>
              <item.icon size={20} />
            </div>
            <span className={`text-xs ${
              currentPath === item.path 
                ? 'text-primary font-medium' 
                : 'text-gray-500'
            }`}>
              {item.name}
            </span>
          </Link>
        ))}
      </nav>
    );
  }
  
  // For desktop (sidebar navigation)
  return (
    <nav className="flex-1">
      <div className="p-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-primary">Stepping4Life</h1>
        </div>
      <ul className="space-y-1 py-4">
        {navItems.map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              className={`flex items-center px-6 py-3 ${
                currentPath === item.path
                  ? 'bg-primary bg-opacity-10 text-primary border-l-4 border-primary'
                  : 'text-gray-500 hover:bg-gray-100'
              }`}
            >
              <item.icon size={18} className="mr-3" />
              <span>{item.name}</span>
            </Link>
          </li>
        ))}
      </ul>
      
      {/* Premium feature section */}
      <div className="mt-auto px-4 py-4">
        <div className="bg-secondary bg-opacity-10 rounded-lg p-4">
          <div className="flex items-center">
            <MapIcon size={18} className="text-secondary mr-2" />
            <h4 className="font-medium text-secondary">Premium Features</h4>
          </div>
          <p className="text-sm text-gray-600 mt-2">
            Unlock advanced analytics and personalized coaching.
          </p>
          <button className="mt-3 text-sm bg-secondary text-white py-1 px-3 rounded-md w-full">
            Upgrade Now
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;